import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Navbar } from "reactstrap";
import { vendorProfileSelector } from "slices/vendor/profileSlice";
import { cdn } from 'constants/common';
import AddLunchSheduleModal from "components/lunch/AddLunch";
import { FaUtensils } from "react-icons/fa";
import LunchStatusSwitch from "components/lunchSwitch/lunchSwitch";
import { fetchLunchSchedule } from "slices/citySlice";

let userSlice;
function Header(props) {
  const [color] = React.useState("transparent");
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [lunchShuduleModal, setlunchShuduleModal] = React.useState({
        show: false,
        item: {}
      });
  const [lunchStatus, setlunchStatus] = useState([]);

  const refDropdown = React.useRef(null);
  useEffect(() => {
    dispatch(fetchLunchSchedule(false, true)).then((res) => {
      setlunchStatus(res.data);
    });
  }, [dispatch]);

  useEffect(() => {
    userSlice = require("../../slices/userSlice");
  }, []);

  const { vendorProfile } = useSelector(vendorProfileSelector);
  const displayUser = vendorProfile;
  
  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (refDropdown.current && !refDropdown.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Close dropdown on route change
  useEffect(() => {
    setDropdownOpen(false);
  }, [location]);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleLogout = () => {
    dispatch(userSlice.logout());
    navigate("/login", { replace: true });
  };
  const handleLunchClose = () => {
  setlunchShuduleModal({
    show: false,
    item: {}
  });
  };

  return (
    <>
      <Navbar
        expand="lg"
        className={
          location.pathname.indexOf("full-screen-maps") !== -1
            ? "navbar-absolute border-0 fixed-top"
            : "navbar-absolute border-0 fixed-top " +
              (color === "transparent" ? "navbar-transparent " : "")
        }
      >
      <AddLunchSheduleModal
        item={lunchShuduleModal.item}
        show={lunchShuduleModal.show}
        onClose={handleLunchClose}
        // callback={callback}
      />
        <div className="header">
          <button className="toggle_sidebar" onClick={props.toggleSidebar}>
            <img src="/images/ham.png" alt="" />
          </button>

          <div className="row_user_side">
            <div ref={refDropdown} className="d-flex align-items-center gap-2 position-relative">
              <LunchStatusSwitch userLunchStatus={lunchStatus} />
              <button 
                onClick={() => setlunchShuduleModal({item:{},show:true})} 
                style={{ height: "38px" , width: "38px" , borderRadius: "50px" ,border: "none", cursor: "pointer" }}
              >
                <FaUtensils size={22} color="#C6C3BD" />
              </button>
              <button className="user_image" onClick={toggleDropdown}>
                {/* <img src="/images/default-person.png" alt="" /> */}
                 {displayUser?.image ? (
                    <img src={cdn + displayUser.image} alt={displayUser.name} />
                  ) : (
                    <img src="/images/default-person.png" alt="Default profile" />
                  )}
                <span></span>
              </button>

              <button
                className={`drop_icon ${dropdownOpen ? "active" : ""}`}
                onClick={toggleDropdown}
              >
                <img src="/images/drop.png" alt="" />
              </button>

              <div
                className={`drop_more_selector ${
                  dropdownOpen ? "active" : ""
                }`}
              >
                <ul>
                  <li>
                    <Link to="/vendor/profile">Profile</Link>
                  </li>
                  <li>
                    <Link to="/vendor/change-password">Change Password</Link>
                  </li>
                  <li>
                    <Link href="#!">Help</Link>
                  </li>
                  <li>
                    <a
                      href=""
                      onClick={handleLogout}
                      className="red_clr"
                    >
                      Log Out
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Navbar>
    </>
  );
}

export default Header;
